import { orderSave } from './../api';
import {market, getExpensesAreasOptionInfo } from '../../../../api'
const finance = {
  namespaced: true,
  state: {
    successCode: 200,
    orderSaveObj: null,
    marketObj: null,
    expensesAreasOptionObj: null
  },
  mutations: {
    ORDER_SAVE_DATA(state,data) {
      state.orderSaveObj = data;
    },
    MARKET_DATA(state,data) {
      state.marketObj = data;
    },
    EXPENSES_AREAS_OPTION_DATA(state,data) {
      state.expensesAreasOptionObj = data;
    },
  },
  actions: {
    //订单保存
    async orderSave({commit}, obj){
      let resp = await orderSave(obj);
      commit('ORDER_SAVE_DATA', resp);
    },
    //市场下拉框
    async market({commit}, obj){
      let resp = await market(obj);
      commit('MARKET_DATA', resp);
    },
    //根据市场ID查询地接社
    async getExpensesAreasOptionInfo({commit}, obj){
      let resp = await getExpensesAreasOptionInfo(obj);
      commit('EXPENSES_AREAS_OPTION_DATA', resp);
    },
  }
}
export default finance



// WEBPACK FOOTER //
// ./src/page/zhubo/finance/store/finance.store.js